import { useUpdateVacancyModal } from "@/features/update-vacancy"
import { useAppDispatch } from "@/shared/lib/redux"
import { fetchVacancies } from "../../model"

export const CreateVacancy = () => {
    const { openCreateVacancyModal } = useUpdateVacancyModal()
    const dispatch = useAppDispatch()

    const onCreate = () => {
        dispatch(fetchVacancies())
    }
    
    return (
        <button onClick={() => openCreateVacancyModal(onCreate)} className="filter_button !w-fit">
            Создать вакансию
        </button>
    )
}